import React from 'react';
import _ResponsivePoster from 'src/components/Modules/ResponsivePoster';

import { compose } from 'redux';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { errKeys } from 'src/constrains/DraggableModules/tools';
import { separateSymbol } from 'src/tools/constant';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import ContentGroupHOC from '../HOC';

const ResponsivePoster = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnReselect,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    handleOnOpenNewTab,
    extraProps,
  } = props || {};
  const { breakpoint } = extraProps || {};
  const { animations, hoverAnimations } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  const layersKey = errKeys.ResponsivePoster.imageLayers;
  const layersError = Object.keys(specificError || {}).reduce((pre, key) => {
    // console.log('key', key);
    const isLayerError =
      key.startsWith(layersKey) && (specificError[key] || []).length > 0;
    if (isLayerError) {
      const id = key.split(separateSymbol)[1];
      return { ...pre, [id]: true };
    }
    return pre;
  }, {});
  const isConvertible = EPreviewSize.WIDE !== breakpoint;
  return (
    <_ResponsivePoster
      staticData={staticData}
      images={dynamicData}
      onItemReselect={handleOnReselect}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      specificError={{ layers: layersError }}
      droppableId={droppableId}
      onOpenNewTab={handleOnOpenNewTab}
      breakpoint={breakpoint}
      animations={animations}
      hoverAnimations={hoverAnimations}
      isConvertible={isConvertible}
    />
  );
};
export default compose(DataHOC, ContentGroupHOC)(ResponsivePoster);
